<template>
  <iRow>
    <UrlElement
      v-for="hashtag in hashtags"
      :key="hashtag"
      v-bind="$props"
      :href="getHashtagPageUrl(hashtag)"
    >
      #{{ hashtag }}
    </UrlElement>
  </iRow>
</template>

<script>
import { BaseStoryCardElementMixin } from "%/dynamic-component-editor/standard-components/base-story-card/base-story-card-element-mixin";
import { useGeneralStore } from "%/dynamic-component-editor/stores/general-store";
import UrlElement from "%/dynamic-component-editor/standard-elements/url-element/UrlElement.vue";
import HashtagClickBehavior from "%/dynamic-component-editor/options/hashtag-click-behavior";

export default {
  name: "HashTags",
  components: { UrlElement },
  elementPanelSettings: {
    displayName: "Hashtags",
    displayIcon: "hashtag",
    elementType: "element",
    elementGroup: "storyElements",
  },
  extends: UrlElement,
  mixins: [BaseStoryCardElementMixin],
  options: [HashtagClickBehavior],
  computed: {
    hashtags() {
      return this.entity.hashtags;
    },
    publicationBaseUrl() {
      return useGeneralStore().getLink("web");
    },
  },
  methods: {
    getHashtagPageUrl(hashtag) {
      return HashtagClickBehavior.hashtagHref(
        this.publicationBaseUrl,
        {
          authorProfile: this.entity.authorId,
          postPage: this.entity.id,
          hashtagPage: hashtag,
        },
        this.getOptionValue(HashtagClickBehavior),
      );
    },
  },
};
</script>
